import { render, staticRenderFns } from "./PropagandistDetails.vue?vue&type=template&id=fcebddb4&"
import script from "./PropagandistDetails.vue?vue&type=script&lang=js&"
export * from "./PropagandistDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports